import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChildren,
  QueryList,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'app-multiple-choice-radio-button',
  templateUrl: './multiple-choice-radio-button.component.html',
  styleUrls: ['./multiple-choice-radio-button.component.scss'],
})
export class MultipleChoiceRadioButtonComponent {
  @Input() options: {
    label: string;
    value: string;
  }[] = [];

  @Input() radioButtonData!: { value: string };
  @Input() key!: string;

  @Output() radioOutput = new EventEmitter<string>();

  @ViewChildren('radioOption') radioOptions!: QueryList<ElementRef>;

  public selectValue(value: string): void {
    let obj: any = {
      value: [value],
      key: this.key,
    };
    this.radioOutput.emit(obj);
  }

  public onKeydown(event: KeyboardEvent, index: number): void {
    const optionsLength = this.options.length;
    let newIndex = index;
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        if (index > 0) {
          newIndex = index - 1;
          this.selectValue(this.options[newIndex].value);
          this.focusRadio(newIndex);
          event.preventDefault();
        }
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        if (index < optionsLength - 1) {
          newIndex = index + 1;
          this.selectValue(this.options[newIndex].value);
          this.focusRadio(newIndex);
          event.preventDefault();
        }
        break;
      case ' ':
      case 'Enter':
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  private focusRadio(index: number): void {
    const radios = this.radioOptions.toArray();
    if (radios[index]) {
      radios[index].nativeElement.focus();
    }
  }

  trackByValue(option: { value: string }) {
    return option.value;
  }
}
